import React, { Component, Fragment } from "react";
import { FormattedNumber, FormattedMessage, defineMessages, FormattedDate } from "react-intl";
import styles from "./ConfirmPayment.module.less";
import classNames from "classnames";
import StatusMessage from "../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../constants/StatusMessages";
import DetailList, { DetailListItem } from "../../../presentational/DetailList/DetailList";
import ContactInfo from "../../../presentational/ContactInfo/ContactInfo";
import PaymentCancelDisclosure from "../../../presentational/PaymentCancelDisclosure/PaymentCancelDisclosure";
import { showCancelDisclosure } from "../../../../domain/payment/paymentUtils";
import moment from "moment";
import PaymentTermsAndConditions from "../../public/legal/PaymentTermsAndConditions/PaymentTermsAndConditions";
import { FormProvider } from "assets/scripts/components/common/form/Form/Form";
import CheckboxFormGroup from "assets/scripts/components/common/form/CheckboxFormGroup/CheckboxFormGroup";
import AccountNumber from "assets/scripts/components/presentational/AccountNumber/AccountNumber";
import sumBy from "lodash/sumBy";
import AmountTable from "./AmountTable/AmountTable";
import MDPatientSheet from "assets/scripts/components/common/MDPatientSheet/MDPatientSheet";
import SpecialtyLivePaymentTermsAndConditions from "../../public/legal/PaymentTermsAndConditions/SpecialtyLivePaymentTermsAndConditions";
const messages = defineMessages({
    paymentAmount: {
        id: "confirmPayment.paymentAmount",
        defaultMessage: "Payment Amount"
    },
    paymentDate: {
        id: "confirmPayment.paymentDate",
        defaultMessage: "Payment Date"
    },
    fromAccount: {
        id: "confirmPayment.fromAccount",
        defaultMessage: "From Account"
    },
    toPay: {
        id: "confirmPayment.toPay",
        defaultMessage: "To Pay"
    },
    agree: {
        id: "confirmPayment.agree",
        defaultMessage: "I agree to the Payment Terms and Conditions"
    }
});
function redact(value, char = "*", visible = 4) {
    if (value == null || value.length <= visible) {
        return value || "";
    }
    return char.repeat(value.length - visible) + value.substr(value.length - visible);
}
const R_BANK_INFO_NAME = /^(.+)\s\((\*+.+)\)$/;
function formatBankInfoName(bankInfoName) {
    const match = bankInfoName.match(R_BANK_INFO_NAME);
    if (match == null) {
        return bankInfoName;
    }
    const acctNum = <AccountNumber value={match[2]}/>;
    return (<Fragment>
			{match[1]} ({acctNum})
		</Fragment>);
}
class ConfirmPayment extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleAgreedChange = (agreed) => this.setState({ agreed });
        this._handleAgreementRead = () => this.setState({ agreementRead: true });
        const { group } = props;
        this.state = {
            agreed: group.primary.requirePaymentAgreement ? false : null,
            agreementRead: !group.primary.specialtyLive
        };
        this._handleConfirm = this._handleConfirm.bind(this);
    }
    render() {
        const { props, state } = this;
        const { payment } = props;
        const { requirePaymentAgreement, specialtyLive } = props.group.primary;
        const buttonClass = classNames("btn mix-btn_fixedWidth btn-action", {
            btn_isDisabled: props.isSaving
        });
        return (<div className={styles.container}>
				<div className="vr vr_x4">
					<h1 className="hdg js-pageHeader">
						<FormattedMessage id="forms.confirmPayment.legend" defaultMessage="Confirm Payment"/>
					</h1>
				</div>

				<StatusMessage isError isActive={props.error ? true : false} error={props.error} customMessage={StatusMessages.PAYMENT.CREATE_ERROR_INTRO} domain={"payment"}/>

				<Fragment>
					<div className="vr vr_x5">
						<DetailList>
							<DetailListItem label={messages.paymentAmount}>
								<FormattedNumber value={sumBy(payment.amounts, it => it.amount)} style="currency" currency="USD"/>
							</DetailListItem>
							<DetailListItem label={messages.paymentDate}>
								<FormattedDate value={payment.scheduledTimestampUtc || moment().toDate()}/>
							</DetailListItem>
							<DetailListItem label={messages.fromAccount}>
								{this._getFromAccountName()}
							</DetailListItem>
							{payment.amounts.length === 1 && props.group.primary.acctNum && (<DetailListItem label={messages.toPay}>
									{this._renderToPay(payment.amounts[0])}
								</DetailListItem>)}
						</DetailList>
					</div>

					{payment.amounts.length > 1 && (<div className="vr vr_x4">
							<AmountTable amounts={payment.amounts} accounts={props.group.accounts}/>
						</div>)}

					{requirePaymentAgreement && (<div className="vr vr_x4">
							<FormProvider disabled={props.isSaving}>
								{!specialtyLive && (<div className={styles.paymentTAndC}>
										<PaymentTermsAndConditions />
									</div>)}
								{specialtyLive && (<SpecialtyLivePaymentTermsAndConditions onReadAgreement={this._handleAgreementRead}/>)}

								<CheckboxFormGroup label={messages.agree} value={state.agreed || false} onChange={this._handleAgreedChange} disabled={specialtyLive && !state.agreementRead}/>
							</FormProvider>
						</div>)}

					{props.group.primary.hasMDPatientInfoSheet && (<MDPatientSheet clientId={props.group.primary.clientId} clientName={props.group.primary.clientName} hasSpanish={props.group.primary.hasMDPatientInfoSheetES}/>)}

					<div className="vr vr_x4">
						<div className="tCombForm">
							<div className="formGroupContainer-btn">
								<button type="button" className={buttonClass} onClick={props.onBack} disabled={props.isSaving}>
									<FormattedMessage id="forms.confirmPayment.back" defaultMessage="Back"/>
								</button>
								{" "}
								<button className={buttonClass} onClick={this._handleConfirm} disabled={props.isSaving || (requirePaymentAgreement && !state.agreed)}>
									<FormattedMessage id="forms.confirmPayment.submit" defaultMessage="Submit"/>
								</button>
							</div>
						</div>
					</div>

					<StatusMessage isLoad isActive={this.props.isSaving}/>

					<div className="vr vr_x4 text mix-text_small">
						<ContactInfo />
						{showCancelDisclosure(payment.scheduledTimestampUtc == null
            ? null
            : moment(payment.scheduledTimestampUtc)) && <PaymentCancelDisclosure />}
					</div>
				</Fragment>
			</div>);
    }
    _getFromAccountName() {
        const { payment } = this.props;
        let fromAccountName;
        if (payment.bankInfo != null && payment.bankInfo.id > 0) {
            fromAccountName = formatBankInfoName(payment.bankInfo.name);
        }
        else {
            fromAccountName = <AccountNumber value={redact(payment.accountNumber)}/>;
            if (payment.bankInfo != null && payment.bankInfo.name) {
                fromAccountName = (<Fragment>
						{payment.bankInfo.name} ({fromAccountName})
					</Fragment>);
            }
        }
        return fromAccountName;
    }
    _renderToPay(amount) {
        const { payableId } = amount;
        const account = this.props.group.accounts.find(it => it.id === payableId);
        if (account == null) {
            return null;
        }
        let toPay = <AccountNumber value={account.acctNum}/>;
        if (process.env.CLIENT == null || account.creditor != null) {
            toPay = (<Fragment>
					{account.creditor} ({toPay})
				</Fragment>);
        }
        return toPay;
    }
    _handleConfirm() {
        if (!this.props.isSaving) {
            this.props.onConfirm({
                ...this.props.payment,
                agreed: this.state.agreed
            });
        }
    }
}
export default ConfirmPayment;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/ConfirmPayment/ConfirmPayment.tsx